import "core-js/modules/es.object.assign.js";
import cx from 'classnames';
import React, { useRef, useState, useLayoutEffect, useMemo, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { ShouldRender } from '../../utils/should-render';
import { useDeferredVisible } from '../../utils/use-deferred-visible';
var classPrefix = 'nib-mask';
var opacityRecord = {
  default: 0.6,
  thin: 0.4,
  thick: 0.8
};
var defaultProps = {
  visible: true,
  destroyOnClose: false,
  forceRender: false,
  color: 'black',
  opacity: 'default',
  disableBodyScroll: true,
  getContainer: null,
  enterTimeout: 100,
  exitTimeout: 100,
  enterTimingFunction: 'linear',
  exitTimingFunction: 'linear'
};
export var Mask = function Mask(p) {
  var props = mergeProps(defaultProps, p);

  var _useState = useState(props.visible),
      active = _useState[0],
      setActive = _useState[1];

  var deferredVisible = useDeferredVisible(props.visible && active);
  var ref = useRef(null);
  useLockScroll(ref, props.disableBodyScroll && active);
  useLayoutEffect(function () {
    if (props.visible) {
      setActive(true);
    }
  }, [props.visible]);

  var afterClose = function afterClose() {
    var _a;

    setActive(false);
    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
  };

  var background = useMemo(function () {
    var _a;

    var opacity = (_a = opacityRecord[props.opacity]) !== null && _a !== void 0 ? _a : props.opacity;
    var rgb = props.color === 'white' ? '255, 255, 255' : '0, 0, 0';
    return "rgba(" + rgb + ", " + opacity + ")";
  }, [props.color, props.opacity]);
  var onMaskClick = props.onMaskClick;
  var handleClick = useCallback(function (evt) {
    if (evt.currentTarget === evt.target) {
      onMaskClick === null || onMaskClick === void 0 ? void 0 : onMaskClick(evt);
    }
  }, [onMaskClick]);
  var node = /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: ref,
    in: deferredVisible,
    timeout: {
      enter: props.enterTimeout,
      exit: props.exitTimeout
    },
    classNames: classPrefix,
    onEntered: props.afterShow,
    onExited: afterClose
  }, withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(classPrefix, props.className),
    onClick: handleClick,
    style: Object.assign(Object.assign({
      background: background
    }, props.style), {
      'display': active ? undefined : 'none',
      // @ts-ignore
      '--enter-timeout': props.enterTimeout + "ms",
      '--enter-timing-function': props.enterTimingFunction,
      '--exit-timeout': props.exitTimeout + "ms",
      '--exit-timing-function': props.exitTimingFunction
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content"
  }, props.children))));
  return /*#__PURE__*/React.createElement(ShouldRender, {
    active: active,
    forceRender: props.forceRender,
    destroyOnClose: props.destroyOnClose
  }, renderToContainer(props.getContainer, node));
};